
function SdOrderRouteCtrl(TranslationService, MaterialService, StoreService, ToastService, WorkflowService, AllocService, $uibModal) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {
        console.log('$onInit');
        ctrl.routeID = '1';
        ctrl.routeName = 'SFS - CHARLESTON' ;
        ctrl.checkpoints = [];
        ctrl.checkpoints.push({
            CheckID: '1',
            Name: 'Despacho',
            PlaceName: 'SAO FRANCISCO DO SUL - DESPACHO',
            Distance: 550,
            NrDays: 1
        });
        ctrl.checkpoints.push({
            CheckID: '2',
            Name: 'Embarque',
            PlaceName: 'SAO FRANCISCO DO SUL',
            Distance: 550,
            NrDays: 1
        });
        ctrl.checkpoints.push({
            CheckID: '4',
            Name: 'Desembarque',
            PlaceName: 'NACIONALIZAÇÃO',
            Distance: 0,
            NrDays: 24
        });
        ctrl.checkpoints.push({
            CheckID: '5',
            Name: 'Chegada',
            PlaceName: 'CHARLESTON',
            Distance: 0,
            NrDays: 1
        });
    };

    ctrl.$onChanges = function (newValues, oldValues) {
        //console.log('SD-ORDER-ITEMS.ONCHANGES');
        if (newValues.order) {
            if (newValues.order.currentValue && newValues.order.currentValue.Details) {
                //ctrl.prepareForEdit(newValues.order.currentValue);
            }
        }
    };

}

SdOrderRouteCtrl.$inject = ['TranslationService', 'MaterialService', 'StoreService', 'ToastService', 'WorkflowService', 'AllocService', '$uibModal'];

seedWebApp.component('sdOrderRoute', {
    controller: SdOrderRouteCtrl,
    bindings: {
        loading: '<',
        order: '<',
        route: '<',
        disabled: '<',
    },
    templateUrl: '/SPA/Orders/sd-order-route.html' + seedWebApp.buildVersion
});
